angular.module('dw-angular-datadog', [])
    .provider('datadog', function () {
        var _datadogConfig = {
            clientToken: '',
            applicationId: '',
            appVersion: '',
            environment: ''
        };

        this.config = function (config) {
            angular.extend(_datadogConfig, config);
            return this;
        };

        this.$get = function () {
            var reportableEnvironments = ['production', 'stage', 'sandbox', 'qa', 'feature'];

            if (reportableEnvironments.includes(_datadogConfig.environment)){
              this.initDatadog();
            }

            return _datadogConfig;
        };

        this.checkForDatadogScript = function () {
            var datadogScript = document.getElementById('datadog-rum-script');
            return !!datadogScript;
        };

        this.initDatadog = function () {
            var datadogInitScript = `
              (function(h,o,u,n,d) {
                  h=h[d]=h[d]||{q:[],onReady:function(c){h.q.push(c)}}
                  d=o.createElement(u);d.async=1;d.src=n
                  n=o.getElementsByTagName(u)[0];n.parentNode.insertBefore(d,n)
              })(window,document,'script','https://www.datadoghq-browser-agent.com/datadog-rum-v4.js','DD_RUM')
              DD_RUM.onReady(function() {
                  DD_RUM.init({
                      clientToken: '${_datadogConfig.clientToken}',
                      applicationId: '${_datadogConfig.applicationId}',
                      site: 'datadoghq.com',
                      service: 'mob-dealerware-web',
                      env: '${_datadogConfig.environment}',
                      version: '${_datadogConfig.appVersion}',
                      sessionSampleRate: 100,
                      sessionReplaySampleRate: 0,
                      trackUserInteractions: true,
                      trackResources: true,
                      trackLongTasks: true,
                      defaultPrivacyLevel: 'mask-user-input',
                  });
              })`;

              var scriptExists = this.checkForDatadogScript();

              if (!scriptExists) {
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.text = datadogInitScript;
                script.id = 'datadog-rum-script';
                document.getElementsByTagName('head')[0].appendChild(script);
              }
        }
    })
    .config(['$provide', function ($provide) {
      $provide.decorator('$exceptionHandler', ['$delegate', function ($delegate) {
          return function (exception, cause) {
              // Call the original $exceptionHandler service
              $delegate(exception, cause);

              // Send the exception information to Datadog
              if (window.DD_RUM) {
                try {
                  window.DD_RUM.addError(exception, {
                      error: {
                          stack: exception.stack
                      },
                      context: {
                          error_message: exception.message,
                          error_cause: cause
                      }
                  });
                } catch (e) {
                  console.error('Datadog error reporting failed: ', e);
                }
              }
          };
      }]);
  }])
  .run(['datadog', function (datadog) {}]);
